import { render, staticRenderFns } from "./Budget_4_20.vue?vue&type=template&id=0d529724&scoped=true&"
import script from "./Budget_4_20.vue?vue&type=script&lang=js&"
export * from "./Budget_4_20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d529724",
  null
  
)

export default component.exports